import { render, staticRenderFns } from "./RemoveSubstituteModal.vue?vue&type=template&id=182cc21e&scoped=true"
import script from "./RemoveSubstituteModal.vue?vue&type=script&lang=js"
export * from "./RemoveSubstituteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cc21e",
  null
  
)

export default component.exports